import { Results as ReactifyResults, useResults } from "@usereactify/search";
import React, { useEffect, useRef, useState } from "react";
import { FilterSortDrawer } from "@app/scripts/reactify/filters/FilterSortDrawer";
import { ResultCardProduct } from "@app/scripts/reactify/results/ResultCardProduct";
import { ResultCardCallout } from "@app/scripts/reactify/results/ResultCardCallout";
import { PaginationLoadMore } from "@app/scripts/reactify/pagination/LoadMore";
import { PaginationNextPage } from "@app/scripts/reactify/pagination/NextPage";
import { VipProvider } from "@app/scripts/react-providers/locales-vip";
import { LockedPage } from "@app/scripts/react-early-access/components/LockedPage";
import config from "@app/config";
import { useStorage } from "@app/scripts/useStorage"

export const Results: React.FC = () => {
  const { resultStats } = useResults();
  const containerRef = useRef(null);
  const [isLocked, setIsLocked] = useState(false);
  const [accessCode, setAccessCode] = useState("");
  const [prevIsLocked, setPrevIsLocked] = useState(isLocked);
  const { getStorage, setStorage } = useStorage()

  const isBrowser = typeof window !== "undefined"

  const getInitialPageSize = () => {
    const storedPageSize = isBrowser && getStorage("pageSize");
    return storedPageSize ? JSON.parse(storedPageSize)?.size : 28;
  };
  const [pageSize, setPageSize] = useState(getInitialPageSize);



  const handlePageSizeStorage = () => {
    if (isBrowser)
      setStorage(
        "pageSize",
        JSON.stringify({
          size: resultStats?.displayedResults || 28,
        }),
        // Cached only for 1 hour
        0.04
      )
  }



  const collectionTitle = document
    .querySelector("[data-collectiontitle]")
    ?.innerHTML.replaceAll(" ", "")
    .toLowerCase()
    .trim();

  useEffect(() => {
    // update top banner item count
    if (isNaN(resultStats?.numberOfResults)) return;
    const itemCounts = document.querySelectorAll("[data-itemcount]");
    if (!itemCounts.length) return;
    itemCounts?.forEach((itemCount) => (itemCount.innerHTML = (resultStats?.numberOfResults || 0).toString()));
  }, [resultStats?.numberOfResults]);

  useEffect(() => {
    const metafileds = document.getElementById("reactify-collection-grid");

    if (!metafileds || !metafileds.textContent) return;

    const { unlockDate, earlyAccessCode, customer } = JSON.parse(metafileds.textContent);
    const lockedState = document.cookie.split("; ").find((row) => row.startsWith(`unlocked_${collectionTitle}`));
    const isUnocked = lockedState && lockedState.split("=")[1] === "true";

    if (earlyAccessCode && isUnocked) return;

    if (unlockDate && new Date(unlockDate) > new Date() && !customer) {
      setIsLocked(true);
    }
    if (earlyAccessCode) {
      setAccessCode(earlyAccessCode);
      setIsLocked(true);

      // Get the 'code' parameter from the current URL
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams) {
        const codeParam = urlParams.get("code");

        // Check if the 'code' parameter matches 'earlyAccessCode'
        if (codeParam && codeParam === earlyAccessCode) {
          setIsLocked(false);
        }
      }
    } else {
      document.cookie = `unlocked_${collectionTitle}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
    }
  }, []);

  useEffect(() => {
    if (prevIsLocked && !isLocked) {
      const date = new Date();
      date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
      document.cookie = `unlocked_${collectionTitle}=true; expires=${date.toUTCString()}; path=/`;
    }
    setPrevIsLocked(isLocked);
  }, [isLocked]);


  return (
    <VipProvider isCollection={true}>
      <FilterSortDrawer
        className={resultStats?.numberOfResults && resultStats.numberOfResults <= 4 ? "single-row" : ""}
      />
      {isLocked ? (
        <LockedPage isCollection={true} code={accessCode} setIsLocked={setIsLocked} />
      ) : (
        <div ref={containerRef} className="main-collection-product-grid">
          <ReactifyResults
            pageSize={pageSize}
            listStyle={{}}
            listClassName="main-collection-product-grid__products"
            includeFields={config.reactify.includeFields}
            excludeFields={config.reactify.excludeFields}
            renderResultCardProduct={(props) => <ResultCardProduct {...props} handlePageSizeStorage={handlePageSizeStorage} />}
            renderResultCardCallout={ResultCardCallout}
            renderPaginationNextPrev={(props) => <PaginationNextPage {...props} pageSize={pageSize} />}
            renderPaginationLoadMore={(props) => <PaginationLoadMore {...props} pageSize={pageSize} />}
            renderNoResults={NoResults}
            renderLoading={() => (
              <div className="rs_loading">
                <h2>Loading...</h2>
              </div>
            )}
          />
        </div>
      )}
    </VipProvider>
  );
};

const NoResults = () => {
  useEffect(() => {
    document.body.classList.add("no-search-results");
    return () => {
      document.body.classList.remove("no-search-results");
    };
  }, []);
  return null;
};
